export default {
    loader: {
        isLoading: false,
        type: 'full' // 'full', 'container', 'modal'
    },
    user: {
        meta: null,
        dependents: [],
        beneficiaries: {
            primary: [],
            contingent: []
        },
        trustee: {
            firstname: null,
            lastname: null,
            relationship: null
        },
        notifications: [],
        bankingDetailsVerifying: false,
        currentSidebarItem: false,
        planDesign: {}
    },
    marketplace: {
        purchasedProducts: {},
        availableProducts: {},
        refusedProducts: {},
        acceptedProducts: {}
    },
    claims: {
        items: []
    },
    spendingAccounts: {
        health: {
            items: null,
            remaining: 0,
            total: 0
        },
        lifestyle: {
            items: null,
            remaining: 0,
            total: 0
        }
    },
    coverage: {
        data: null
    },
    usage: {
        data: null
    },
    invoices: {
        items: []
    },
    signup: {
        beneficiaries: {
            contingent: [],
            primary: []
        },
        dependents: [],
        spendingAccounts: {
            hsaAmount: 0,
            lsaAmount: 0
        },
        trustee: null,
        saved: {},
        userDetails: null
    },
    whitelabel: {
        name: null,
        logo: null,
        logoSmall: null,
        primaryColor: null,
        secondaryColor: null,
        buttonTextColor: null,
        watermarkWhite: null,
        watermarkColor: null
    },
    notifier: {
        showing: false,
        verbiage: 'Something failed, please try again',
        type: 'error',
        lastUpdated: new Date() // the last time anything on the site was updated (should be updated after each xhr request)
    }
};